import { render, staticRenderFns } from "./ConsigneeDocumentUploadLogin.vue?vue&type=template&id=41379684&"
import script from "./ConsigneeDocumentUploadLogin.vue?vue&type=script&lang=ts&"
export * from "./ConsigneeDocumentUploadLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports